var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rides_table"},[(_vm.showBalance)?_c('h3',[_vm._v(_vm._s(("Credit Balance: " + (this.formatPrice(this.creditBalance)))))]):_vm._e(),_c('Table',{attrs:{"headers":_vm.headers,"items":_vm.creditData,"loading":_vm.loading,"height":"400"},scopedSlots:_vm._u([{key:"item.adminUser",fn:function(ref){
var item = ref.item;
return [(item.adminUser)?_c('div',[_vm._v(_vm._s(item.adminUser)+" (Admin)")]):_c('div',[_vm._v(_vm._s(_vm.userName))])]}},{key:"item.valueUsd",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(("" + (_vm.formatPrice(item.valueUsd))))+" ")]}},{key:"item.createdWithTzUser",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(("" + (_vm.datetimeFormatToAmericanFormat(item.createdWithTzUser))))+" ")]}},{key:"item.comment",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.comment)+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }